// Avatar config helper — character-based system.
// Each user picks a `character_id` from the curated CHARACTERS roster (lib/characters.js).
import { CHARACTERS, getCharacter } from "./characters";

export { CHARACTERS };

/**
 * Returns the image URL for an avatar config.
 * Backwards-compatible: accepts either {character_id} or legacy DiceBear {style, seed, ...}.
 */
export function buildAvatarUrl(config /* size unused, kept for API compat */) {
  if (!config) return defaultCharacter().img;
  if (config.character_id) {
    return getCharacter(config.character_id).img;
  }
  // Legacy DiceBear config — render via DiceBear (graceful fallback for old saved avatars)
  if (config.style && config.seed) {
    const { style, seed, backgroundColor = "2EE38A", flip = false } = config;
    const params = new URLSearchParams({
      seed: String(seed),
      backgroundColor: String(backgroundColor).replace("#", ""),
    });
    if (flip) params.set("flip", "true");
    return `https://api.dicebear.com/9.x/${style}/svg?${params.toString()}`;
  }
  return defaultCharacter().img;
}

export function getAvatarCharacter(config) {
  if (config?.character_id) return getCharacter(config.character_id);
  return defaultCharacter();
}

export function defaultCharacter() {
  return CHARACTERS[0];
}

export function defaultAvatar(userIdOrName) {
  // Pick a deterministic default character from the roster based on the user's id.
  const idStr = String(userIdOrName || "guest");
  let hash = 0;
  for (let i = 0; i < idStr.length; i++) hash = (hash * 31 + idStr.charCodeAt(i)) >>> 0;
  const char = CHARACTERS[hash % CHARACTERS.length];
  return { character_id: char.id };
}
